import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import DeleteIcon from '../icons/DeleteIcon'

interface FormFieldArrayProps {
  titleKey: string
  appendItem?: () => void
  removeItem?: () => void
  hidden?: boolean
  sequenceNumber?: number
  // Optional class for the fields wrapper (e.g. to lay them out side by side).
  bodyClassName?: string
}

function FormFieldArray({
  titleKey,
  appendItem,
  removeItem,
  hidden,
  sequenceNumber,
  bodyClassName,
  children,
}: React.PropsWithChildren<FormFieldArrayProps>) {
  const { t } = useTranslation()

  return (
    <React.Fragment key={titleKey + hidden}>
      {
        !hidden
        && (
          <fieldset className="mb-2" key={titleKey + hidden}>
            <legend className="heading align-items-end">
              <h3>
                {t(titleKey)}
                {sequenceNumber !== undefined && sequenceNumber}
              </h3>

              <div className="btn-group">
                {
                  removeItem !== undefined
                  && (
                    <button
                      className="btn btn-sm btn-link btn-trash"
                      type="button"
                      aria-label={t('buttons.remove')}
                      onClick={removeItem}
                    >
                      <DeleteIcon />
                    </button>
                  )
                }
                {
                  appendItem !== undefined
                  && (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-add">{t('buttons.addNew')}</Tooltip>}
                    >
                      <button
                        className="btn btn-sm btn-success text-white"
                        type="button"
                        onClick={appendItem}
                      >
                        <i className="far fa-plus" />
                      </button>
                    </OverlayTrigger>
                  )
                }
              </div>

            </legend>
            {
              children !== undefined && ((Array.isArray(children) && children.length > 0) || React.isValidElement(children))
              && (
                <div className={bodyClassName}>
                  {children}
                </div>
              )
            }
          </fieldset>
        )
      }
    </React.Fragment>
  )
}

FormFieldArray.defaultProps = {
  appendItem: undefined,
  removeItem: undefined,
  hidden: false,
  sequenceNumber: undefined,
  bodyClassName: undefined,
}

export default FormFieldArray
